import { Button } from '@mui/material';
import { useState } from 'react';
import ExoDialog from '../../exo/ExoDialog';
import { ECTextBlocks } from '../../email-system/ECTextBlocks';
import DrawIcon from '@mui/icons-material/Draw';
import { useUserPreferences } from '../../../global/useUserPreferences';

export const SignatureBlockStyle = ({
  setSelectedSignature,
  selectedSignature,
  credentials,
}) => {
  const [open, setOpen] = useState(false);
  const { preferences, updatePreferences } = useUserPreferences();

  function handleSelect(block) {
    setSelectedSignature(block);
    setOpen(false);

    // save in preferences
    const signatureMap = preferences?.emailSignatureMap || {};
    if (credentials)
      updatePreferences(
        '',
        {
          emailSignatureMap: {
            ...signatureMap,
            [credentials.imapUsername]: block.id,
          },
        },
        true
      );
  }

  return (
    <>
      <Button
        className="grouped"
        onClick={() => setOpen(true)}
        sx={{ minWidth: '37px' }}
      >
        <div className="w-4 h-4 flex justify-center items-center">
          <DrawIcon />
        </div>
      </Button>
      <ExoDialog open={open} limitWidth onClose={() => setOpen(false)}>
        <ECTextBlocks onSelect={handleSelect} type={'signature'} />
      </ExoDialog>
    </>
  );
};
